<template>
    <cv-modal :visible.sync="visible" @hide="clear" :hasFooter="false" c="modal default large" :title="'产品详情 - ' + product.name">
        <section v-if="$root.hasPermission(permissions.financing.product.show.meta)" class="section">
            <div class="head">
                <span class="title">基本信息</span>
                <span class="operation">
                    <cv-button v-if="$root.hasPermission(permissions.financing.product.update)" v-show="!section.basic.edit" @click="editBasic" c="link primary mini underline">修改</cv-button>
                    <cv-button v-if="$root.hasPermission(permissions.financing.product.update)" v-show="section.basic.edit" @click="saveBasic" c="link primary mini underline distant-x">保存</cv-button>
                    <cv-button v-if="$root.hasPermission(permissions.financing.product.update)" v-show="section.basic.edit" @click="showBasic" c="link primary mini underline">取消</cv-button>
                </span>
            </div>
            <cv-form label="产品名称" :labelWidth="4.5" c="form default medium distant-y">
                <cv-input v-if="section.basic.edit" v-model="section.basic.data.name" c="input default small"></cv-input>
                <div v-else>{{product.name}}</div>
            </cv-form>
            <cv-form :label="section.basic.edit ? '满仓金额' : '产品仓位'" :labelWidth="4.5" c="form default medium distant-y">
                <cv-input v-if="section.basic.edit" v-model="section.basic.data.fullAmount" c="input default small"></cv-input>
                <div v-else>
                    <template v-if="$root.hasPermission(permissions.financing.product.show.amount)">{{product.amount / 100}} / {{product.fullAmount / 100}} ({{product.position}}%)</template>
                    <template v-else>{{product.position}}%</template>
                </div>
            </cv-form>
            <cv-form label="风险等级" :labelWidth="4.5" c="form default medium distant-y">
                <cv-select v-if="section.basic.edit" v-model="section.basic.data.risk" :options="enumsProductRisks" c="select default small"></cv-select>
                <div v-else>
                    <cv-tag v-if="product.risk" :c="'tag ' + enums.productRisks[product.risk].level + ' mini'">{{enums.productRisks[product.risk].text}}</cv-tag>
                </div>
            </cv-form>
            <cv-form label="产品状态" :labelWidth="4.5" c="form default medium distant-y">
                <div v-if="section.basic.edit">
                    <cv-switch v-model="section.basic.data.active" c="switch success large"></cv-switch>
                    <span>{{section.basic.data.active ? "活跃" : "归档"}}</span>
                </div>
                <div v-else>
                    <cv-tag v-if="product.state == 'ACTIVE'" c="tag success small">活跃</cv-tag>
                    <cv-tag v-else-if="product.state == 'ARCHIVED'" c="tag default small">归档</cv-tag>
                    <cv-tag v-else c="tag error small">其他</cv-tag>
                </div>
            </cv-form>
        </section>
        
        <section v-if="$root.hasPermission(permissions.financing.product.show.index) && $root.hasPermission(permissions.financing.product.show.fund)" class="section">
            <div class="head">
                <span class="title">关联基金/指数</span>
                <span class="operation">
                    <cv-button v-if="$root.hasPermission(permissions.financing.product.update)" v-show="!section.index.edit" @click="editIndex" c="link primary mini underline">修改</cv-button>
                    <cv-button v-if="$root.hasPermission(permissions.financing.product.update)" v-show="section.index.edit" @click="saveIndex" c="link primary mini underline distant-x">保存</cv-button>
                    <cv-button v-if="$root.hasPermission(permissions.financing.product.update)" v-show="section.index.edit" @click="showIndex" c="link primary mini underline">取消</cv-button>
                </span>
            </div>
            <cv-form v-if="$root.hasPermission(permissions.financing.product.show.index)" label="关联基金" :labelWidth="4.5" c="form default medium distant-y">
                <cv-select v-if="section.index.edit" v-model="section.index.data.fundId" @search="searchFund" :options="sectionIndexSelectFundData" searchable c="select default small"></cv-select>
                <template v-else>
                    <div class="content" v-if="fund">{{fund.name}} ({{fund.code}})</div>
                    <div v-else>无</div>
                </template>
            </cv-form>
            <cv-form v-if="$root.hasPermission(permissions.financing.product.show.fund)" label="关联指数" :labelWidth="4.5" c="form default medium distant-y">
                <cv-select v-if="section.index.edit" v-model="section.index.data.indexId" @search="searchIndex" :options="sectionIndexSelectIndexData" searchable c="select default small"></cv-select>
                <template v-else>
                    <div class="content" v-if="index">{{index.name}} ({{index.code}})</div>
                    <div v-else>无</div>
                </template>
            </cv-form>
        </section>
        
        <section v-if="$root.hasPermission(permissions.financing.product.show.positionRecord)" class="section">
            <div class="head">
                <span class="title">调仓记录</span>
                <span class="operation">
                    <cv-button v-if="hasPositionRecords" @click="section.positionRecords.show = !section.positionRecords.show" c="link primary mini underline">{{section.positionRecords.show?"收起":"展开"}}</cv-button>
                </span>
            </div>
            <cv-timeline v-if="hasPositionRecords" v-show="section.positionRecords.show" :data="positionRecords" timeFormat="YYYY-MM-DD" c="timeline default medium distant-y">
            </cv-timeline>
            <div class="empty" v-else>60个交易日内无调仓。</div>
        </section>
        
        <section v-if="showPositionCharts && $root.hasPermission(permissions.financing.product.show.chart)" class="section">
            <div class="head">
                <span class="title">仓位比较</span>
                <span class="operation" style="font-size: .85em;">
                    <cv-check v-if="index && fund" v-model="section.positionCharts.paintIndex" c="check primary large distant-x">指数</cv-check>
                    <cv-check v-if="index && fund" v-model="section.positionCharts.paintFund" c="check primary large">基金</cv-check>
                </span>
            </div>
            <div>
                <position-charts v-if="visible" :product="product" :paintIndex="section.positionCharts.paintIndex" :paintFund="section.positionCharts.paintFund"></position-charts>
            </div>
        </section>
    </cv-modal>
</template>

<script>
    import permissions from "../../js/permissions.js";
    
    import PositionCharts from "./PositionCharts.vue";
    
    export default {
        name: "ModalProduct",
        components: {
            PositionCharts
        },
        data() {
            return {
                permissions: permissions,
                visible: false,
                product: {},
                section: {
                    basic: {
                        edit: false,
                        data: {
                            name: null,
                            fullAmount: null,
                            risk: null,
                            active: null
                        }
                    },
                    index: {
                        edit: false,
                        data: {
                            indexId: null,
                            fundId: null
                        },
                        select: {
                            index: {
                                keyword: null,
                                data: []
                            },
                            fund: {
                                keyword: null,
                                data: []
                            }
                        }
                    },
                    positionRecords: {
                        show: false
                    },
                    positionCharts: {
                        paintIndex: true,
                        paintFund: true
                    }
                },
                enums: {
                    productRisks: {
                        HIGH: {
                            text: "高风险",
                            level: "error"
                        },
                        MIDDLE: {
                            text: "中风险",
                            level: "warn"
                        },
                        LOW: {
                            text: "低风险",
                            level: "primary"
                        }
                    }
                }
            };
        },
        computed: {
            fund() {
                return this.product.fund;
            },
            index() {
                return this.product.index;
            },
            sectionIndexSelectIndexData() {
                let indexes = this.section.index.select.index.data;
                let sectionIndexSelectIndexData = [];
                if (!indexes) {
                    return sectionIndexSelectIndexData;
                }
                for (let i=0; i<indexes.length; i++) {
                    let index = indexes[i];
                    sectionIndexSelectIndexData.push({
                        id: index.id,
                        name: index.name + " (" + index.code + ")"
                    });
                }
                return sectionIndexSelectIndexData;
            },
            sectionIndexSelectFundData() {
                let funds = this.section.index.select.fund.data;
                let sectionIndexSelectFundData = [];
                if (!funds) {
                    return sectionIndexSelectFundData;
                }
                for (let i=0; i<funds.length; i++) {
                    let fund = funds[i];
                    sectionIndexSelectFundData.push({
                        id: fund.id,
                        name: fund.name + " (" + fund.code + ")"
                    });
                }
                return sectionIndexSelectFundData;
            },
            sectionPositionChartsPaintIndex() {
                return this.section.positionCharts.paintIndex;
            },
            sectionPositionChartsPaintFund() {
                return this.section.positionCharts.paintFund;
            },
            hasPositionRecords() {
                return this.positionRecords && this.positionRecords.length > 0;
            },
            positionRecords() {
                let hasAmountPermission = this.$root.hasPermission(permissions.financing.product.show.amount)
                
                if (!this.product.positionRecords) {
                    return [];
                }
                let positionRecords = [];
                for (let i=this.product.positionRecords.length-1; i>=0; i--) {
                    let positionRecord = this.product.positionRecords[i];
                    let name;
                    if (hasAmountPermission) {
                        name = (positionRecord.amount / 100) + "(" + positionRecord.position + "%)";
                    } else {
                        name = positionRecord.position + "%";
                    }
                    positionRecords.push({
                        name: name,
                        time: positionRecord.date.toDate(),
                        level:  positionRecord.position > 0 ? "error" : "success"
                    });
                }
                return positionRecords;
            },
            showPositionCharts() {
                return this.index?.id || this.fund?.id;
            },
            enumsProductRisks() {
                let enums = [];
                for (let key in this.enums.productRisks) {
                    enums.push({
                        id: key,
                        name: this.enums.productRisks[key].text
                    });
                }
                return enums;
            }
        },
        watch: {
            index(newValue, oldValue) {
                if (!newValue) {
                    this.section.positionCharts.paintIndex = false;
                    this.section.positionCharts.paintFund = true;
                }
                if (!oldValue && newValue) {
                    this.section.positionCharts.paintIndex = true;
                }
            },
            fund(newValue, oldValue) {
                if (!newValue) {
                    this.section.positionCharts.paintIndex = true;
                    this.section.positionCharts.paintFund = false;
                }
                if (!oldValue && newValue) {
                    this.section.positionCharts.paintFund = true;
                }
            },
            sectionPositionChartsPaintIndex(newValue) {
                if (!newValue && this.fund) {
                    this.section.positionCharts.paintFund = true;
                }
            },
            sectionPositionChartsPaintFund(newValue) {
                if (!newValue && this.index) {
                    this.section.positionCharts.paintIndex = true;
                }
            }
        },
        methods: {
            show(product) {
                this.product = product;
                this.visible = true;
            },
            hide() {
                this.visible = false;
                this.clear();
            },
            clear() {
                this.product = {};
                this.showBasic();
                this.showIndex();
                this.hidePositionRecords();
            },
            // 基础信息
            editBasic() {
                this.section.basic.data.name = this.product.name;
                this.section.basic.data.fullAmount = this.product.fullAmount / 100;
                this.section.basic.data.active = this.product.state == "ACTIVE";
                this.section.basic.data.risk = this.product.risk;
                this.section.basic.edit = true;
            },
            showBasic() {
                this.clearBasic();
                this.section.basic.edit = false;
            },
            clearBasic() {
                this.section.basic.data.name = null;
                this.section.basic.data.fullAmount = null;
                this.section.basic.data.active = null;
                this.section.basic.data.risk = null;
            },
            async saveBasic() {
                let product = await this.updateProduct({
                    id: this.product.id,
                    name: this.section.basic.data.name,
                    fullAmount: this.section.basic.data.fullAmount * 100,
                    risk: this.section.basic.data.risk,
                    state: this.section.basic.data.active ? "ACTIVE" : "ARCHIVED"
                });
                if (product) {
                    this.product.name = product.name;
                    this.product.fullAmount = product.fullAmount;
                    this.product.position = product.position;
                    this.product.risk = product.risk;
                    this.product.state = product.state;
                    this.showBasic();
                }
            },
            // 关联指数/基金
            editIndex() {
                if (this.index) {
                    this.section.index.data.indexId = this.index.id;
                    this.section.index.select.index.data.push(this.index);
                }
                if (this.fund) {
                    this.section.index.data.fundId = this.fund.id;
                    this.section.index.select.fund.data.push(this.fund);
                }
                this.section.index.edit = true;
            },
            showIndex() {
                this.clearIndex();
                this.section.index.edit = false;
            },
            clearIndex() {
                this.section.index.data.indexId = null;
                this.section.index.select.index.data = [];
                this.section.index.data.fundId = null;
                this.section.index.select.fund.data = [];
            },
            async saveIndex() {
                let product = await this.updateProduct({
                    id: this.product.id,
                    index: {
                        id: this.section.index.data.indexId
                    },
                    fund: {
                        id: this.section.index.data.fundId
                    }
                });
                if (product) {
                    this.$set(this.product, "fund", product.fund);
                    this.$set(this.product, "index", product.index);
                    this.showIndex();
                }
            },
            async searchIndex(keyword) {
                this.section.index.select.index.keyword = keyword;
                this.section.index.select.index.data = await this.$remotes.server.financing.index.search(keyword, "INDEX");
            },
            async searchFund(keyword) {
                this.section.index.select.fund.keyword = keyword;
                this.section.index.select.fund.data = await this.$remotes.server.financing.index.search(keyword, "FUND");
            },
            // 调仓记录
            hidePositionRecords() {
                this.section.positionRecords.show = false;
            },
            // 仓位比较（图）
            clearPositionCharts() {
                this.section.positionCharts.paintIndex = true;
                this.section.positionCharts.paintFund = true;
            },
            // 保存产品
            async updateProduct(product) {
                return await this.$remotes.server.financing.product.update(product);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .section {
        margin-bottom: 1em;
        
        .head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: .5em 0;
            border-bottom: solid 1px var(--color-border);
            
            .title {
                font-size: .9em;
            }
        }
        
        .form {
            .content {
                width: min-content;
            }
        }
        
        .timeline {
            margin-top: 1em;
        }
        .empty {
            margin-top: 1em;
            font-size: .9em;
            color: var(--color-primary-text);
        }
    }
    
    .form {
        min-height: 1.8em;
    }
</style>
